import { useCallback, useMemo } from 'react';
import { useGetFundsInformation } from '../../../hooks/useGetFundsInformation';
import { useGetUserContractFund } from '../containers/AssetSection/components/AutoInvest/hooks/useGetUserContractFund';
import { useCheckHasAssetActivities } from './useCheckHasAssetActivities';

export const useHandleRequiredServices = () => {
  const fundsInformationResponses = useGetFundsInformation();

  const assetsActivitiesResponse = useCheckHasAssetActivities();

  const getUserContractFund = useGetUserContractFund();

  const isFetching =
    fundsInformationResponses.isFetching || assetsActivitiesResponse.isFetching;
  const isLoading =
    fundsInformationResponses.isLoading ||
    assetsActivitiesResponse.isLoading ||
    getUserContractFund.isLoading;
  const isError =
    fundsInformationResponses.isError || assetsActivitiesResponse.isError;

  const errorMessage: string | undefined = useMemo(() => {
    if (
      !fundsInformationResponses.isError &&
      !assetsActivitiesResponse.isError
    ) {
      return undefined;
    }
    return (
      fundsInformationResponses.errorMessage ||
      assetsActivitiesResponse.error?.message ||
      ''
    );
  }, [
    fundsInformationResponses.isError,
    fundsInformationResponses.errorMessage,
    assetsActivitiesResponse.isError,
    assetsActivitiesResponse.error,
  ]);

  const refetchOnError = useCallback(async () => {
    fundsInformationResponses.isError && (await refetchOnError());
    assetsActivitiesResponse.isError &&
      (await assetsActivitiesResponse.refetch());
  }, [
    fundsInformationResponses.isError,
    fundsInformationResponses.refetchOnError,
    assetsActivitiesResponse.isError,
    assetsActivitiesResponse.refetch,
  ]);

  return {
    isFetching,
    isLoading,
    errorMessage,
    refetchOnError,
    isError,
  };
};
